import { render, staticRenderFns } from "./TZCard.vue?vue&type=template&id=0b213533&scoped=true&"
import script from "./TZCard.vue?vue&type=script&lang=js&"
export * from "./TZCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b213533",
  null
  
)

export default component.exports